export default function DataTableApuracaoRow(props: any) {
    return (<p style={{display: "inline", marginRight: "10px"}}>
        {props.value}
    </p>)
}